/**
 * 登录/注册页 — 对齐 pages.md §三 首次引导 + account-and-membership.md
 *
 * 路由：/auth
 * 支持：邮箱密码注册/登录，切换模式
 */

import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Input } from '@hump/ui';
import { useAuthStore } from '../stores/auth';

export function AuthPage() {
  const navigate = useNavigate();
  const { register, login, loading, error } = useAuthStore();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const ok = mode === 'login'
      ? await login(email, password)
      : await register(email, password, displayName || undefined);

    if (ok) {
      navigate('/shelf');
    }
  }

  return (
    <div className="min-h-screen bg-warm-white dark:bg-warm-dark flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        {/* 品牌 */}
        <div className="text-center mb-8">
          <p className="text-5xl mb-2">🐪</p>
          <h1 className="text-2xl font-serif text-camel-dark">Hump</h1>
          <p className="text-sm text-charcoal/50 dark:text-charcoal-light/50 mt-1">
            蓄满驼峰，读得更远。
          </p>
        </div>

        {/* 模式切换 */}
        <div className="flex gap-1 mb-6 bg-warm-white dark:bg-warm-dark p-1 rounded-lg">
          <button
            onClick={() => setMode('login')}
            className={`flex-1 py-2 rounded-md text-sm font-medium transition-colors ${
              mode === 'login' ? 'bg-camel text-white' : 'text-charcoal/60 dark:text-charcoal-light/60'
            }`}
          >
            登录
          </button>
          <button
            onClick={() => setMode('register')}
            className={`flex-1 py-2 rounded-md text-sm font-medium transition-colors ${
              mode === 'register' ? 'bg-camel text-white' : 'text-charcoal/60 dark:text-charcoal-light/60'
            }`}
          >
            注册
          </button>
        </div>

        {/* 表单 */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {mode === 'register' && (
            <div>
              <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-1">
                昵称（可选）
              </label>
              <Input
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="你的昵称"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-1">
              邮箱
            </label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="user@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-1">
              密码
            </label>
            <Input
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 8 位"
            />
          </div>

          {error && (
            <p className="text-error text-sm">{error}</p>
          )}

          <Button
            variant="primary"
            size="lg"
            disabled={loading || !email || !password}
            className="w-full"
          >
            {loading ? '处理中...' : mode === 'login' ? '登录' : '注册'}
          </Button>
        </form>

        {/* 跳过 */}
        <button
          onClick={() => navigate('/shelf')}
          className="block w-full text-center text-sm text-charcoal/40 dark:text-charcoal-light/40 hover:text-charcoal/60 dark:hover:text-charcoal-light/60 mt-4"
        >
          稍后再说，先逛逛 →
        </button>
      </div>
    </div>
  );
}
